import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BlindType, BlindTypes } from '@root/app.interfaces';

@Component({
	selector: 'app-gallery-filters',
	templateUrl: './gallery-filters.component.html',
	styleUrls: ['./gallery-filters.component.scss', './gallery-filters.responsive.scss'],
})
export class GalleryFiltersComponent {
	@Input() selectedFilter: BlindType;
	@Output() selectFilter = new EventEmitter<BlindType>();

	protected readonly BlindTypes = BlindTypes;
}
